<template>
  <div :class="['yxp-nav clear-fix', isLogin && 'isLogin']">
    <el-popover
      v-if="isLogin"
      v-model="rightDia"
      width="380"
      placement="bottom"
      popper-class="web003-nav-popover"
    >
      <div
        slot="reference"
      >
        <div class="protal-nav-tab">
          <div
            class="protal-user"
          >
            <img
              v-if="loadErr"
              src="../../assets/image/icon_default_avatar.png"
              class="avatar"
            >
            <img
              v-else
              :src="cp_user.avatar"
              @error="loadFail"
            >
            <p class="user-name">
              <span>{{ cp_user.realName }}</span><span>{{ cp_identity_info.schoolType === 2 ? '指导员' : cp_identity_info.identity.identityName }}</span>
            </p>
            <i class="el-icon-caret-bottom " />
          </div>
        </div>
        <div class="fl protal-nav-tab" />
      </div>
      <div
        v-loading="loading"
        element-loading-background="rgba(0, 0, 0, 0)"
        class="r-dia-box"
      >
        <div class="clear-fix r-dia-head">
          <span class="fl">切换身份</span>
          <a
            v-if="!cp_support"
            href="javascript:;"
            class="fr text-btn"
            @click="signout(false)"
          >退出登录</a>
        </div>
        <div
          class="ident-select"
          :class="{'inden-yxp': cp_isYxp}"
          @click.stop="choiceIdentily"
          @mouseup.stop=""
        >
          <el-select
            ref="identSelect"
            v-model="cp_uuid"
            class="nav-select"
            :class="{'no-caret': cp_support}"
            placeholder="请选择"
            popper-class="ident-popper"
            :disabled="Boolean(cp_support)"
            @change="uuidChange"
          >
            <el-option
              v-for="item in parseOrgInfo"
              :key="item.uuid"
              :disabled="item.status !== 1"
              :label="getIdentityLabel(item)"
              :value="item.uuid"
            />
          </el-select>
          <div class="nav-ident-log" />
          <div
            v-if="!cp_support"
            class="nav-ident-tag"
          >
            点击切换
          </div>
        </div>
      </div>
    </el-popover>
    <div
      v-else
      class="btn-login"
      @click="login"
    >
      登 录
    </div>
  </div>
</template>

<script>
import api, { getRouterMap } from './proxy';
import { JsonParse } from '../../lib/functional';
const { mapGetters } = window.Vuex;
export default {
    name: 'YxpNav',
    props: {
        linkMqtt: {
            type: Boolean,
            default: true,
        },
        websiteMsg: {
            type: Object,
            default: () => {},
        },
    },

    data () {
        let t = sessionStorage.getItem('mqtt-alert-time') || 0;
        let allowMessage = new Date().getTime() > t * 1 + 3600 * 1000;
        let addr = this.$store.getters['global/nav/loginAddress'];
        return {
            allowMessage, // 开发模式一小时只发一次单点登录消息
            rightDia: false,
            loading: false,
            loadErr: false,
            defultModule: [
                Object.assign({}, addr, {
                    hash: '#/index',
                }),
            ],
        };
    },
    computed: {
        ...mapGetters({
            cp_user: 'global/loginInfo',
            cp_orgInfo: 'global/orgInfo',
            cp_identity: 'global/userIdentity',
            cp_userid: 'global/userId',
            cp_orgId: 'global/orgId',
            isDev: 'global/nav/isDev',
            isLogin: 'global/isLogin',
        }),
        parseOrgInfo () {
            let res = [];
            this.cp_orgInfo.forEach(item => {
                if (item.identity.identityId === 11) {
                    res.push(...item.student.map(sd => {
                        return Object.assign({}, item, {
                            relationShip: this.parseShip(item.relationShip, sd.studentId),
                            studentName: sd.studentName || '',
                            loginName: sd.loginName || '',
                            uuid: sd.studentUuid || '',
                        });
                    }));
                } else {
                    res.push(item);
                }
            });
            return res;
        },
        cp_orgType () {
            return this.$store.getters['global/currentOrg'].orgType;
        },
        cp_support () {
            return this.cp_user.supported;
        },
        cp_isYxp () {
            return [0].includes(this.cp_orgType);
        },
        cp_site () {
            let name = this.$store.state.global.nav.travel.site;
            if (this.$store.state['global'].nav.commonAppId) { // 用于备课显示appname
                for (let itm of this.$store.getters['permission/appList']) {
                    if (itm.appId === this.$store.state['global'].nav.commonAppId) {
                        name = itm.appName;
                    }
                }
            } else if (this.$store.state['system']) {
                name = this.$store.getters['system/currentApp'].appName;
            }
            return name;
        },
        cp_uuid: {
            get () {
                return this.cp_identity_info.uuid;
            },
            set (v) {
                let company = this.parseOrgInfo || [];
                let temp = company.find(itm => itm.uuid === v);
                // this.$emit('before-change', temp);
                this.loading = true;
                this.$store.dispatch('global/setOrg', temp);
                getRouterMap({
                    orgId: temp.orgId,
                    orgType: temp.orgType,
                    identityId: temp.identity.identityId,
                    userId: this.cp_userid,
                    uuid: v,
                }).then((data) => {
                    this.$store.dispatch('permission/setPermission', data.data);
                    this.$emit('change-identity', data);
                    this.rightDia = false;
                    // const list = data.data.appList;
                    // const item = list.find(itm => itm.appId === 42);
                    // if (!item) {
                    //     this.backToIndex();
                    // }
                }).catch(e => {
                    this.$emit('change-identity', e);
                }).finally(() => {
                    this.loading = false;
                });
            },
        },
        cp_doors () { // 接口给的所有业务层模块
            return this.$store.getters['global/nav/navAppList'];
        },
        cp_static () {
            return this.defultModule.concat(this.cp_doors.filter(itm => this.staticApp.includes(itm.appId)));
        },
        cp_agile () {
            return this.cp_doors.filter(itm => !this.staticApp.includes(itm.appId));
        },
        cp_staticSort () { // 我的空间
            let arr = this.cp_static;
            return Array.from({ length: Math.ceil(arr.length / 3) }).map((v, m) => {
                return Array.from({ length: 3 }).map((k, n) => {
                    return arr[3 * m + n] || {};
                });
            });
        },
        cp_agileSort () { // 构建分类后的applist
            let arr = [];
            for (let itm of this.cp_doors) {
                let flag = false;
                if (arr.length === 0) {
                    arr.push(
                        {
                            appCategoryName: itm.appCategoryName,
                            children: [],
                        }
                    );
                } else {
                    for (let i = 0; i < arr.length; i++) {
                        if (arr[i].appCategoryName === itm.appCategoryName) {
                            flag = true;
                        }
                    }
                    if (flag === false) {
                        arr.push({
                            appCategoryName: itm.appCategoryName,
                            children: [],
                        });
                    }
                }
            }
            for (let item of arr) {
                for (let item1 of this.cp_doors) {
                    if (item.appCategoryName === item1.appCategoryName) {
                        item.children.push(item1);
                    }
                }
            }
            return arr;
        },
        cp_identity_info () {
            return Object.assign({
                identity: { identityId: -1001 },
            }, this.$store.getters['global/currentOrg']);
        },
        origin () {
            return this.isDev && 'https://m6.anoah.com' || location.origin;
        },
    },
    watch: {
        'cp_user.avatar' () {
            this.loadErr = false;
        },
    },
    mounted () {
        let self = this;
        if (this.linkMqtt) {
            self.$store.dispatch('global/linkMqtt');
            self.unwatchFn = self.$store.watch(function (state) {
                return state.global.mqttMessage;
            }, function (a) {
                let data = JsonParse(a);
                if (data.type === 10) { // 单点登录
                    self.actLongDistance(data.param);
                } else if (data.type === 20) { // 当前身份被禁用
                    self.actIdentityDisabled(data.param);
                }
            });
        };
        if (location.pathname === '/yxp-beike/') {
            this.style = 'height: calc(100vh - 48px)';
        }
    },
    beforeDestroy () {
        this.unwatchFn();
    },
    methods: {
        login () {
            sessionStorage.setItem('webModulePagePath', this.$route.path);
            let param = '';
            if (this.$route.query) {
                param = JSON.stringify(this.$route.query);
                sessionStorage.setItem('webModulePageParam', param);
            }
            this.$store.dispatch('global/nav/loginOff', {
                backUrl: location.origin + location.pathname,
                path: this.$route.path,
                noAuthorize: true,
                param,
                logo: encodeURI(this.websiteMsg.logo || ''),
                copyright: encodeURI(this.websiteMsg.copyright || ''),
                icpFilingCode: encodeURI(this.websiteMsg.icpFilingCode || ''),
                policeFilingCode: encodeURI(this.websiteMsg.policeFilingCode || ''),
            });
        },
        backToIndex () {
            let self = this;
            self.$message({
                type: 'error',
                duration: process.env.NODE_ENV === 'development' ? 0 : 2000,
                showClose: true,
                message: '对不起，您暂时没有访问权限！',
                onClose () {
                    // self.$store.dispatch('system/act_backToIndex');
                    // self.$store.dispatch('global/nav/loginOff');
                    sessionStorage.setItem('webModulePagePath', self.$route.path);
                    if (process.env.NODE_ENV === 'development') {
                        self.$store.dispatch('system/act_login_off', {
                            backUrl: location.origin + location.pathname,
                            path: self.$route.path,
                            noAuthorize: true,
                        });
                    } else {
                        self.$store.dispatch('system/act_backToIndex');
                    }
                },
            });
        },
        async signout (service = false) {
            if (service) {
                const res = await api.manageLogout({
                    identityId: this.cp_user.identityId,
                });
                if (res.errcode !== 0) {
                    this.$message.error(res.errmsg);
                    return false;
                }
            }
            this.$emit('login-out');
            this.$store.dispatch('global/loginOut');
            const thirdLogoutInfo = sessionStorage.getItem('thirdLogoutInfo');
            if (thirdLogoutInfo) {
                // 第三方退出登录关闭页面
                window.close();
                return;
            }
            // this.$store.dispatch('global/nav/loginOff', {
            //     backUrl: location.origin + location.pathname,
            //     path: this.$route.path,
            //     noAuthorize: true,
            // });
        },
        getIdentityLabel (item) {
            if (item.identity.identityId === 11) { // 家长
                return item.studentName + '-' + (item.relationShip) + '-' + item.orgName;
            } else if (item.identity.identityId === 12) { // 学生
                return '学生-' + item.orgName;
            } else if (item.schoolType === 2) {
                return '指导员-' + item.orgName;
            } else {
                return item.identity.identityName + '-' + item.orgName;
            }
        },
        choiceIdentily () {
            this.$refs.identSelect.toggleMenu();
        },
        uuidChange (v) {
            this.visible = false;
            if (!v) {
                let self = this;
                this.$message({
                    type: 'error',
                    showClose: true,
                    duration: 2000,
                    message: '当前身份已失效！',
                    onClose () {
                        self.signout(false);
                    },
                });
            };
        },
        /* 多点登录 */
        actLongDistance ({ userid, device, firstLoginTime }) {
            let self = this;
            if (device === self.$store.getters['global/equipment'].device && firstLoginTime > self.$store.getters['global/firstLoginTime'] && self.allowMessage) {
                self.allowMessage = false;
                if (!self.isDev) {
                    self.$store.dispatch('global/loginOut');
                };
                self.$emit('before-mqtt-msg-close', 'repeatLogin');
                this.$alert('你的账号在别处登录', '提示', {
                    confirmButtonText: '确定',
                    type: 'warning',
                    callback: action => {
                        self.allowMessage = true;
                        self.$emit('mqtt-msg-close', 'repeatLogin');
                        if (!self.isDev) {
                            this.$store.dispatch('global/nav/loginOff');
                        } else {
                            sessionStorage.setItem('mqtt-alert-time', new Date().getTime());
                        };
                    },
                });
            }
        },
        /* 当前身份被禁用 */
        actIdentityDisabled (data) {
            let self = this;
            let getters = self.$store.getters;
            let isChecked = data.orgId === getters['global/orgId'] && data.orgType === getters['global/orgType'];
            let orgLg = self.$store.getters['global/orgInfo'].length;
            if (getters['global/isLogin'] && self.allowMessage && isChecked) {
                self.allowMessage = false;
                self.$emit('before-mqtt-msg-close', 'orgDisabled');
                /* 移除登录信息，防止用户不点击弹窗 */
                if (!self.isDev) {
                    self.$store.dispatch('global/loginOut');
                };
                self.$alert('单位已停用，请启用后再试！', {
                    confirmButtonText: '确定',
                    type: 'warning',
                    callback: action => {
                        self.allowMessage = true;
                        self.$emit('mqtt-msg-close', 'orgDisabled');
                        if (!self.isDev) {
                            if (orgLg > 1) {
                                self.$store.dispatch('global/loginOut', {
                                    storage: 'keep',
                                    method: 'identity',
                                });
                            } else {
                                self.$store.dispatch('global/loginOut');
                            }
                        };
                    },
                });
            }
        },
        parseShip (relationShip, studentId) {
            let ship = (relationShip.find(s => s.studentId === studentId) || {}).relationship;
            if (ship) {
                return ship;
            }
            return '';
        },
        loadFail () {
            this.loadErr = true;
        },
    },
};
</script>

<style scoped lang="scss">
@import "../../sass/theme.scss";
@import "../../sass/reset.scss";
.yxp-nav {
    &.isLogin {
        height: 96px;
    }
    .btn-login {
        color: #FFFFFF;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 70px;
        height: 36px;
        background-color: #2873E9;
        border-radius: 4px;
        cursor: pointer;
        margin-left: 20px;
        margin-right: 40px;
        &:hover {
            background-color: #4b8af0;
        }
    }
}
.portal-contain {
    height: 100%;
    background: $gray-bg;
    /*position: fixed;*/
    /*top: 0;*/
    /*left: 0;*/
}

.protal-nav-tab {
    padding: 0 10px;
    padding-right: 30px;
    height: 96px;
    display: flex;
    align-items: center;
    position: relative;
    .el-badge {
        line-height: 1;
        cursor: pointer;
    }
}

.protal-user {
    /*padding: 0 20px;*/
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    cursor: pointer;
    padding: 4px 0;
    line-height: 40px;
    color: $title-col;
    span {
        padding-left: 15px;
        word-break: keep-all;
    }
    &:hover {
        color: $primary;
    }
    img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
    }
    .el-icon-caret-bottom {
        line-height: 40px;
        margin-left: 8px;
        font-size: 1.3em;
        -webkit-transition: transform .2s;
        -moz-transition: transform .2s;
        -ms-transition: transform .2s;
        -o-transition: transform .2s;
        transition: transform .2s;
    }
    &.open {
        color: $primary;
        .el-icon-caret-bottom {
            -webkit-transform: rotate3d(0, 0, 1, 180deg);
            -moz-transform: rotate3d(0, 0, 1, 180deg);
            -ms-transform: rotate3d(0, 0, 1, 180deg);
            -o-transform: rotate3d(0, 0, 1, 180deg);
            transform: rotate3d(0, 0, 1, 180deg);
        }
    }
}

.user-slide {
    color: $gray-font;
    background: $gray-bg;
    position: absolute;
    top: 100%;
    left: 0;
    .user-slide-item {
        padding: 0 20px;
        cursor: pointer;
        white-space: nowrap;
        &:hover {
            color: $primary;
        }
    }
}

.slide-enter-active, .slide-leave-active {
    transition: all .2s ease;
    transform-origin: top;
}

.slide-enter, .slide-leave-to {
    transform: scale3d(1, .8, 1);
    opacity: 0;
}

.cur-el-tabs {
    height: calc(100% - 91px);
    margin-left: -20px;
    margin-right: -20px;
    .el-tab-pane {
        height: 100%;
    }
}

.r-dia-box {
    height: 100%;
}

.r-dia-head {
    line-height: 50px;
}

.el-select {
    margin-bottom: 15px;
    width: 100%;
}

.text-btn {
    color: $primary;
}

.home-cont-title {
    margin-bottom: 20px;
}

.portal-footer {
    background: $gray-bg;
    margin-top: $datum-length * 3;
}

.ident-select {
    position: relative;
    height: 36px;
    margin-bottom: 5px;
    cursor: pointer;
    &.inden-yxp {
        .nav-ident-log {
            background: url("../../assets/image/ident-log-admin.png") center center no-repeat;
        }
    }
    .nav-ident-log {
        position: absolute;
        top: 0;
        left: 4px;
        height: 36px;
        width: 36px;
        background: url("../../assets/image/ident-log-user.png") center center no-repeat;
    }
    .nav-ident-tag {
        position: absolute;
        top: 0;
        right: 30px;
        line-height: 36px;
        color: $primary;
    }
}
</style>

<style lang="scss">
@import "../../sass/theme.scss";
@import "../../sass/reset.scss";
/* 公共css */

.portal-contain {
    & > .el-scrollbar__wrap {
        height: calc(100% + 17px);
        & > .el-scrollbar__view {
            padding-top: $datum-length * 6;
        }
    }
    .el-scrollbar__bar {
        z-index: 3000;
    }

    .protal-router {
        min-height: calc(100vh - 48px);
    }
    .download-list {
        width: 100%;
        min-height: calc(100vh - 48px);
        // min-height: calc(100vh - 48px);
    }
}
.el-menu.portal {
    border: none;
    .el-menu-item {
        & + .el-menu-item {
            border-top-color: transparent;
        }
    }
    .el-submenu__title, .el-menu-item {
        font-size: 16px;
        min-width: 180px;
        color: $gray-font !important;
    }
    .el-menu-item.is-active {
        color: $primary !important;
    }
    .el-submenu.is-active .el-submenu__title {
        color: $primary !important;
    }
}

.user-t-title {
    line-height: $datum-length * 6.5;
    height: $datum-length * 6.5;
    padding: 0 20px 0 45px;
    position: relative;
    font-weight: 600;
    font-size: 16px;
    border-bottom: 1px solid $gray-bg;
    &:before {
        content: '';
        display: block;
        position: absolute;
        top: 50%;
        left: 22px;
        margin-top: -4px;
        border: 2px solid $gray-font;
        width: 4px;
        height: 4px;
        border-radius: 50%;
    }
    &.user-title-gray {
        color: $gray-font;
    }
    .el-button {
        margin-top: 10px;
    }
}
.cur-el-tabs {
    .el-tabs__nav {
        padding: 0 20px;
    }
    .el-tabs__active-bar {
        left: 20px;
    }
}

.por-right-dialog.right-dialog {
    .el-tabs__content {
        height: calc(100% - 36px);
    }
    .el-dialog__body {
        padding: 20px;
        height: calc(100% - 30px);
        padding-bottom: 0;
    }
    .el-tabs__header {
        margin-bottom: 0;
    }
    .el-dialog {
        margin-top: $datum-length * 6 !important;
        height: calc(100% - #{$datum-length * 6});
    }
    .el-scrollbar__wrap {
        overflow-x: auto;
    }
}
.com-text-dia {
    .el-dialog__body {
        padding: 10px 20px;
        height: 220px;
    }
    .el-scrollbar__wrap {
        overflow-x: auto;
    }
}

.por-left-dialog.el-dialog__wrapper {
    .el-dialog {
        margin-top: 0;
        height: 100%;
        .el-dialog__header {
            height: 56px;
        }
    }

    .left-dia-box {
        padding: 10px 30px;
    }
    .el-dialog__body {
        height: calc(100% - 56px);
    }
    .el-scrollbar {
        height: 100%;
    }
    .el-scrollbar__wrap {
        height: calc(100% + 17px);
    }

    .por-title {
        color: #2693F1;
        cursor: pointer;
        display: flex;
        align-items: center;
        padding: 0 10px;
        img {
            margin-right: 10px;
            height: 26px;
        }
    }
    .el-dialog__headerbtn:hover .el-dialog__close {
        color: #2693F1;
    }
}

.com-tooltip.el-tooltip__popper.is-light {
    border-color: $orange;
    .popper__arrow {
        border-top-color: $orange;
    }
}
.el-tabs.cur-el-tabs {
    .el-tabs__nav {
        width: 100%;
    }
    .el-tabs__nav {
        display: flex;
        justify-content: space-between;
    }
    .el-tabs__item {
        text-align: center;
        height: 36px;
        flex: 1 1 auto;
        font-weight: 600;
        color: $gray-font;
    }
    .is-active {
        color: #505050;
    }
}

.nav-select.el-select {
    &.no-caret {
        .el-select__caret.el-input__icon {
            display: none;
        }
    }
    .el-input .el-input__inner {
        background: $light-green;
        border-color: $light-green;
        color: #505050;
        padding-left: 44px;
        padding-right: 90px;
    }
    .el-select__caret.el-input__icon {
        color: $primary;
    }
    .el-select-dropdown__wrap {
        max-height: 500px;
    }
}
.ident-popper {
    width: 380px;
    .el-select-dropdown__item {
        overflow: visible;
    }
}

/* 无背景按钮 */
.el-button.btn-plain {
    border-color: $primary;
    color: $primary;
}
.login-out-btn {
    color: #2ED095;
    font-size: 14px !important;
    cursor: pointer;
}

.model {
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: transparent;
    top: 0;
    left: 0;
    cursor: auto;
    z-index: 1;
}
.f-icon-right{
    margin-right:0px;

}
.tab-list{
    margin-top: 20px !important;
    padding: 0 !important;
}
.web003-nav-popover {
    &.el-popper[x-placement^=bottom] {
        margin-top: 0px;
    }
}
</style>
